import useTranslate from 'modules/local/useTranslate'
import React, {useMemo, useState} from 'react'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {NullAsDefault} from 'views/Shared'
import {getId, getType} from "../../../../apis/model/base";
import {showDeleteConfirmDialog} from "../../factory/createConfirmDialog";
import {Modal} from "antd";
import {withProps} from "recompose";
import LoadingBlock from "../../../Loading/LoadingBlock";
import CRUD from "../../../Shared/enums/CRUD";
import useShopActions from "./useShopActions";
import {ShopFormCreate, ShopFormEdit} from "../components/ShopForm";
import {FetchShopById} from "../containers/FetchEntity";

export const useShopForm = ({
                                organization,
                                autoRefresh = true,
                            }) => {
    const t = useTranslate()
    const [refreshKey, setRefreshKey] = useState()
    const onError = notifyOnError(t)
    const onRefresh = () => {
        if (autoRefresh) {
            setRefreshKey(Date.now())
        }
    }
    const owner_type = getType(organization);
    const owner_id = getId(organization);

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const onCancel = () => {
        setAction({})
    }

    const {
        createNewShop,
        editShopInfo,
        deleteShop
    } = useShopActions({
        notifyListeners: {
            onCancel: onCancel,
            onRefresh: onRefresh,
        }
    })

    const confirmDelete = (id) => {
        if (id) {
            showDeleteConfirmDialog({
                translate: t,
                title: 'delete shop',
                message: 'are you sure you want to delete this shop',
                onOk: () => {
                    deleteShop({}, {id})
                },
            })
        }
    }

    const handleAction = (action, params) => {
        const id = getId(params)
        switch (action) {
            case CRUD.CREATE:
            case CRUD.UPDATE:
                setAction({type: action, value: params})
                break
            case CRUD.DELETE:
                confirmDelete(id)
                break
            default:
                break
        }
    }

    const modal = useMemo(() => {
        if (!!!action?.type) return null;
        let params = {}
        let modal_params = {}
        let Component = NullAsDefault
        let Wrapper = ({children}) => children({item: {}})
        const id = getId(action?.value)
        switch (action?.type) {
            case CRUD.CREATE:
                Component = ShopFormCreate
                modal_params = {
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('create shop')}
                        </div>
                    ),
                }
                params = {
                    owner_type,
                    owner_id,
                    container: organization,
                    onSubmit: (values) => {
                        createNewShop(values, {type: 'organization', id: organization?.id})
                        onCancel()
                    },
                }
                break
            case CRUD.UPDATE:
                Wrapper = withProps({id})(FetchShopById)
                Component = ShopFormEdit
                modal_params = {
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('edit shop')}
                        </div>
                    ),
                }
                params = {
                    owner_type,
                    owner_id,
                    container: organization,
                    onSubmit: (values) => {
                        editShopInfo(values, {id})
                        onCancel()
                    },
                }
                break
            default:
                break
        }
        return (
            <Modal
                width={720}
                footer={null}
                onCancel={onCancel}
                open={action?.type}
                destroyOnHidden={true}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({item, isLoading}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Component
                                {...params}
                                {...{onCancel}}
                                initialValues={item}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action, organization?.id])

    return {
        modal,
        onCancel,
        handleAction,

        confirmDelete,
        refreshKey,

        createNewShop,
        editShopInfo,
        deleteShop
    }
}
